import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import { statusLabel, LEAVE_STATUS_LABELS } from './attendanceStatus';

const EVENT_TYPE_LABELS = {
  ptm: 'PTM',
  sports: 'Sports',
  cultural: 'Cultural',
  exam: 'Exam',
  other: 'Event',
};

function eventTypeLabel(type) {
  if (!type) return 'Event';
  const key = String(type).toLowerCase();
  return EVENT_TYPE_LABELS[key] || type.replace(/_/g, ' ');
}

export default function AttendanceDayDetailModal({ day, open, onOpenChange }) {
  if (!day) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {day.date
              ? new Date(`${day.date}T12:00:00`).toLocaleDateString(undefined, {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })
              : 'Day detail'}
          </DialogTitle>
        </DialogHeader>
        <dl className="space-y-2 text-sm">
          <div className="flex justify-between gap-4">
            <dt className="text-muted-foreground">Status</dt>
            <dd className="font-medium">
              {day.display_status === 'empty'
                ? 'Not recorded'
                : statusLabel(day.display_status)}
            </dd>
          </div>
          {day.day_name ? (
            <div className="flex justify-between gap-4">
              <dt className="text-muted-foreground">Day</dt>
              <dd>{day.day_name}</dd>
            </div>
          ) : null}
          {day.leave_application_status ? (
            <div className="flex justify-between gap-4">
              <dt className="text-muted-foreground">Leave application</dt>
              <dd className="font-medium text-right">
                {LEAVE_STATUS_LABELS[day.leave_application_status]
                  || day.leave_application_status}
              </dd>
            </div>
          ) : null}
          {day.remarks ? (
            <div>
              <dt className="text-muted-foreground mb-1">Remarks</dt>
              <dd className="rounded-md bg-muted/50 p-2">{day.remarks}</dd>
            </div>
          ) : null}
          {day.display_status === 'holiday' && day.holiday_name ? (
            <div className="flex justify-between gap-4">
              <dt className="text-muted-foreground">Holiday</dt>
              <dd className="font-medium text-right">{day.holiday_name}</dd>
            </div>
          ) : null}
          {(day.school_events || []).length > 0 ? (
            <div>
              <dt className="text-muted-foreground mb-2">School events</dt>
              <dd className="space-y-2">
                {day.school_events.map((ev, idx) => (
                  <div key={`${ev.title}-${idx}`} className="rounded-md border border-border p-2">
                    <p className="font-medium">{ev.title}</p>
                    {ev.event_type ? (
                      <p className="text-xs text-muted-foreground mt-0.5">
                        {eventTypeLabel(ev.event_type)}
                      </p>
                    ) : null}
                    {ev.location ? (
                      <p className="text-xs text-muted-foreground mt-0.5">{ev.location}</p>
                    ) : null}
                    {ev.description ? (
                      <p className="text-xs mt-1">{ev.description}</p>
                    ) : null}
                  </div>
                ))}
              </dd>
            </div>
          ) : null}
        </dl>
      </DialogContent>
    </Dialog>
  );
}
